import { useCallback, useLayoutEffect, useState } from 'react';
import throttle from 'lodash.throttle';

export interface UseComponentSizeData {
    measuredRef: (node: HTMLElement | null) => void;
    width: number;
    height: number;
}

export const useComponentSize = (): UseComponentSizeData => {
    const [size, setSize] = useState({ width: 0, height: 0 });
    const [ref, setRef] = useState<HTMLElement | null>(null);

    const measuredRef = useCallback((node: HTMLElement | null) => {
        if (node !== null) {
            setRef(node);
        }
    }, []);

    useLayoutEffect(() => {
        const handleResize = (): void => {
            if (ref) {
                setSize({ width: ref.offsetWidth, height: ref.offsetHeight });
            }
        };
        handleResize();
        const throttledHandleResize = throttle(handleResize, 200);

        window.addEventListener('resize', throttledHandleResize);
        return () => {
            window.removeEventListener('resize', throttledHandleResize);
        };
    }, [ref]);

    return { measuredRef, ...size };
};
